var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"small":""}},'v-icon',_vm.$attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}],null,false,2121009928)},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }